import { Mapper } from '../../../common/ddd/mapper.base';
import { formatDeviation } from '../../../common/utils/format-deviation.util';
import { formatDuration } from '../../../common/utils/format-duration.util';
import { ChallengeTimeInCallsAggregateRoot } from '../../../core/domain/aggregates/challenge-insights/challenge-time-in-calls.aggregate-root';
import { MetricValueType } from '../../../interface/dtos';
import { GetAccountMetricsInsightsAveragesResponseDto } from '../../../interface/dtos/challenge-insights/get-account-metrics-insights-averages.response.dto';

export class ChallengeTimeInCallsAggregateRootMapper
  implements
    Omit<
      Mapper<
        ChallengeTimeInCallsAggregateRoot,
        GetAccountMetricsInsightsAveragesResponseDto
      >,
      'toDomain'
    >
{
  toResponse(
    entity: ChallengeTimeInCallsAggregateRoot
  ): GetAccountMetricsInsightsAveragesResponseDto {
    return ChallengeTimeInCallsAggregateRootMapper.toResponse(entity);
  }
  static toResponse(
    entity: ChallengeTimeInCallsAggregateRoot
  ): GetAccountMetricsInsightsAveragesResponseDto {
    const isUniqueUsers = entity.type === MetricValueType.UniqueUsers;
    return {
      deviation: `${formatDeviation(Math.round(entity.deviationPercentage))}`,
      beforeValue: Math.round(entity.beforeValue),
      afterValue: Math.round(entity.value),
      beforeFormattedValue: isUniqueUsers
        ? String(Math.round(entity.beforeValue))
        : formatDuration(entity.beforeValue),
      afterFormattedValue: isUniqueUsers
        ? String(Math.round(entity.value))
        : formatDuration(entity.value),
      averageDeviation: `${formatDeviation(
        Math.round(entity.averageDeviationPercentage)
      )}`,
      beforeAverage: Math.round(entity.beforeAverage),
      afterAverage: Math.round(entity.average),
      beforeFormattedAverage: isUniqueUsers
        ? String(Math.round(entity.beforeAverage))
        : formatDuration(entity.beforeAverage),
      afterFormattedAverage: isUniqueUsers
        ? String(Math.round(entity.average))
        : formatDuration(entity.average),
    };
  }
}
